export default __webpack_public_path__ + "static/media/collectif.81e97bd3.jpg";